import {defineStore} from "pinia";
import api from "@/plugins/axios"

export const useLogsStore = defineStore('logs', {
    state: () => ({
        logs: [],
        availableDates: [],
        isLoading: false,
        error: null,
        filters: {
            date: '',
            search: '',
            level: '',
            limit: 100,
        },
    }),
    actions: {
        async fetchLogs() {
            this.isLoading = true;
            this.error = null;

            try {
                const params = new URLSearchParams();
                if (this.filters.date) params.append('date', this.filters.date);
                if (this.filters.search) params.append('search', this.filters.search);
                if (this.filters.level) params.append('level', this.filters.level);
                if (this.filters.limit) params.append('limit', this.filters.limit.toString());

                const response = await api.get(`logs?${params.toString()}`);
                this.logs = response.data.data;
            } catch (error) {
                this.error = error.response?.data?.message || error.message;
            } finally {
                this.isLoading = false;
            }
        },

        async fetchAvailableDates() {
            try {
                const response = await api.get('logs/dates');
                this.availableDates = response.data.data;
            } catch (error) {
                console.error('Failed to fetch available dates:', error);
            }
        },

        updateFilter(filter, value) {
            this.filters[filter] = value;
            this.fetchLogs();
        },
    },
});
